import { Button, DialogContent, InputAdornment, TextField, Grid2 } from '@mui/material';
import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import { DialogHeader } from '../../../components/DialogHeader';
import { Product } from '../types';
import { useGetCompanyVendorProfileQuery } from '../../../services/vendorProfile';
import { CURRENCY_SYMBOLS } from '../../../types';
import { Currencies } from '../../../types';
import useAuth from '../../../components/Auth';

interface Props {
    onSubmit: (payload: Omit<Product, 'id' | 'images' | 'digitalDelivery' | 'isBundle'>) => void;
    onClose: () => void;
	open: boolean;
}

const AddProductDialog = ({ onSubmit, onClose, open }: Props) => {
	const [imgUrl, setImgUrl] = useState<string>('');
	const {userProfile} = useAuth();
	const {data: vendorProfile} = useGetCompanyVendorProfileQuery(undefined, {skip: !userProfile});
	const currencySymbol = CURRENCY_SYMBOLS[vendorProfile?.currency as Currencies];

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		const formData = new FormData(e.target as HTMLFormElement);
		e.preventDefault();
		const filteredFormDataObject = Object.fromEntries(Object.entries(Object.fromEntries(formData)).filter(([, value]) => value !== ''));
		onSubmit(filteredFormDataObject as Omit<Product, 'id' | 'images' | 'digitalDelivery' | 'isBundle'>); // TODO: what's up with this type?
	};	

	return <Dialog open={open} fullWidth onClose={onClose}>
		<DialogHeader title='New Product' imgUrl={imgUrl} onClose={onClose} />
		<DialogContent>
			<form onSubmit={handleSubmit}>
				<Grid2 container spacing={2}>
					<Grid2>
						<TextField fullWidth required autoComplete='off' label='SKU' name='sku' />
					</Grid2>
					<Grid2>
						<TextField autoComplete='off' label='Image URL' name='imgUrl' onChange={(e) => setImgUrl(e.target.value)} />
					</Grid2>
					<Grid2 size={12}>
						<TextField fullWidth required autoComplete='off' label='Name' name='name' />
					</Grid2>
					<Grid2 size={12}>
						<TextField fullWidth multiline rows={3} autoComplete='off' label='Description' name='description' />
					</Grid2>
					<Grid2>
						<TextField required autoComplete='off' label='Unit of measure' name='uom' defaultValue='pcs' />
					</Grid2>
					<Grid2>
						<TextField required type='number' autoComplete='off' label='Price per unit' name='pricePerUnit' inputProps={{ step: 'any' }} slotProps={{
							input: {
								endAdornment: <InputAdornment position="end">{currencySymbol}</InputAdornment>,
							},
						}}/>
					</Grid2>
					<Grid2 size={12}>
						<TextField fullWidth multiline rows={3} autoComplete='off' label='Notes' name='notes' />
					</Grid2>
					<Grid2 size={12}>
						<Button type='submit' variant='contained'>Save</Button>
					</Grid2>
				</Grid2>
			</form>
		</DialogContent>
	</Dialog>;   
};

export default AddProductDialog;
